

var Model = require("../types/Model.js");

/**
	* Devices:
	* 	foraTNG - referes to the Fora TN'G blood glucose meter,
	* 	nonin3230: refers to the Nonin 3230 pulse oximeter,
	* 	A&DBP: refers to the A & D BLE blood pressuere monitor,
	* 	A&DWeight: refers to the A & D BLE weight scale,
	* 	metawear: refers to the mbientlabs Metawear Metamotion C sensor,
	*   foraTNGtemp - refers to the Fora TN'G body temperature meter
	*/

var MODEL_MAP = {
	activity: "deviceactivity",
	bloodpressure: "devicebloodpressure",
	bloodsugar: "foraTNG",
	bloodoxygen: "deviceoxygen",
	weight: "deviceweight",
	bodytemperature: "forair20"
};

var PROXY_EVENTS = [
	"updated",
	"reading"
];

var PROXY_TRIGGERS = [
	"showinfo",
	"workflow",
	"begin",
	"clean",
	"pair"
];

module.exports = new Model({
	name: "myhealthdevice",
	listeners: listeners,
	triggers: triggers,
	init: init,
	uninit: uninit,
});

function init(){
	this._deviceType = null;
	this.push(false);
}

function uninit(){
	this._deviceType = null;
	this.push(false);

	this._connectionTimer = null;
	this._readingTimer =  null;
	this._progressInterval = false;
}

function triggers() {
	return PROXY_TRIGGERS.reduce(function(result, trigger) {
		result[trigger] = function(data) {
			if(data && data.deviceType) {
				this._deviceType = data.deviceType;
			}

			var deviceType = this._deviceType;

			if(!deviceType) return;
			if (trigger === "clean") {
				this.push(false);
				const deviceTypeToName = {
					"bodytemperature": "body temperature",
					"bloodpressure": "blood pressure",
					"bloodsugar": "blood sugar",
					"bloodoxygen": "blood oxygen",
					"weight": "weight",
					"activity": "activity"
				};
				this.emit("usermetrics:trigger:track", `close read from device modal for ${deviceTypeToName[deviceType]}`, {
					"device type": MODEL_MAP[deviceType]
				});
			}
			else this.push(deviceType);

			var model = MODEL_MAP[deviceType];
			this.emit(model + ":trigger:" + trigger, data);
		};
		return result;
	}, {});
}

function listeners() {
	return Object.keys(MODEL_MAP).reduce(function(_result, deviceType) {
		var modelName = MODEL_MAP[deviceType];
		return PROXY_EVENTS.reduce(function(result, event){
			result[modelName + ":" + event] = function(data) {
				if(this._deviceType === deviceType) {
					this.dispatch(deviceType + ":" + event, data);
				}
			};
			return result;
		}, _result);
	}, {});
}
